var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-sheet', {
    staticClass: "page-text pa-16",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "color": "transparent"
    }
  }, [!_vm.isUserAuthorized ? [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v(" 열람할 권한이 없습니다. ")])] : [_vm.item.content ? [_vm._v(" " + _vm._s(_vm.item.content) + " ")] : [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v(" 작성한 내용이 없습니다. ")])], _c('v-row', {
    staticClass: "mt-14 row--x-small page-text--sm grey-9--text",
    attrs: {
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 작성일시: " + _vm._s(_vm.item.createdAt.toDateTime()) + " ")])]), _vm.isUserItem ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('expo-inquiry-form', _vm._b({
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', Object.assign({}, attrs, _vm.attrs_actionBtn, {
          loading: _vm.loading,
          disabled: _vm.disabled_userUpdate
        }), false), on), [_c('span', [_vm._v(" 수정하기 ")])])];
      }
    }], null, false, 2548850161)
  }, 'expo-inquiry-form', {
    value: _vm.item,
    program: _vm.program
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    on: {
      "click": _vm.remove
    }
  }, 'v-btn', Object.assign({}, _vm.attrs_actionBtn, {
    loading: _vm.loading
  }), false), [_c('span', [_vm._v(" 삭제하기 ")])])], 1)] : _vm._e()], 2)]], 2), _vm.isUserAuthorized ? [_c('v-divider'), _c('v-sheet', {
    staticClass: "page-text pa-16",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "color": "transparent"
    }
  }, [_vm.item.reply ? [_vm._v(" " + _vm._s(_vm.item.reply) + " ")] : [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v(" 답변이 등록되지 않았습니다. ")])], _c('v-row', {
    staticClass: "mt-14 row--x-small page-text--sm grey-9--text",
    attrs: {
      "align": "baseline"
    }
  }, [_vm.item.repliedAt ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v(" 답변일시: " + _vm._s(_vm.item.repliedAt.toDateTime()) + " ")])])] : _vm._e(), _vm.isUserHost ? [_vm.item.repliedAt ? [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")])] : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('expo-inquiry-reply', _vm._b({
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', Object.assign({}, attrs, _vm.attrs_actionBtn, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm.item.reply ? [_vm._v(" 수정하기 ")] : [_vm._v(" 답변하기 ")]], 2)])];
      }
    }], null, false, 1996685150)
  }, 'expo-inquiry-reply', {
    value: _vm.item,
    program: _vm.program
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    on: {
      "click": _vm.hide
    }
  }, 'v-btn', Object.assign({}, _vm.attrs_actionBtn, {
    loading: _vm.loading
  }), false), [_c('span', [_vm._v(" 블라인드 ")])])], 1)] : _vm._e()], 2)], 2)] : _vm._e(), _vm.item._id != _vm.items.at(-1)._id ? _c('v-divider') : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }